angular.module('app.admin.broadcastManager.broadcastManagerService').controller('imageDialogController', [
    '$uibModalInstance', 'images',
    function ($uibModalInstance, images) {
        let $ctrl = this;
        $ctrl.images = images;

        $ctrl.selectImage = function (img) {
            $uibModalInstance.close(img);
        };
    }
]);



// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/imageDialogController.js